import React from 'react';
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from "./components/ScrollToTop";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import HomePage from './components/HomePage';
import Admin from './components/Admin';
import CreateCV from './components/CreateCV';
import FastApplication from './components/FastApplication';
import JobsPage from './components/JobsPage';
import JobDetailsPage from './components/JobDetailsPage';
import NotFoundPage from './components/NotFoundPage';
import AboutUsPage from './components/AboutUsPage';


function App() {
  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/fastApplication" element={<FastApplication />} />
        <Route path="/vilinkonjic" element={<Admin />} />
        <Route path="/create-cv" element={<CreateCV />} />
        <Route path="/jobs-page" element={<JobsPage />} />
        <Route path="/about" element={<AboutUsPage />} />   {/* ✅ New About route */}
        <Route path="/jobs/:id" element={<JobDetailsPage />} />
        {/* <Route path="/about" element={<AboutUsPage />} />
        <Route path="/blogs" element={<BlogsPage />} /> */}
        {/* Wildcard route for 404 Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
        <ToastContainer
        position="top-left"
        autoClose={5000}        // Closes after 3s
        hideProgressBar={false} // Shows a progress bar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Router>
    </HelmetProvider>
  );
}

export default App;
